<button (click)="openDialog()" *ngIf="useButton" color="primary" mat-raised-button>
	Upload Pricing Data
</button>

<span (click)="openDialog()" *ngIf="useText" class="link primary-text">{{ text }}</span>

<button (click)="openDialog()" *ngIf="isMenuButton" class="{{ labelClass }}" mat-menu-item>
	<span>Upload Pricing Data</span>
</button>
